<template>
    <div>
        <CCard class="tarjetaGesto">
            <CCardHeader>
                <CRow>
                            <CCol sm="5">
                                <span v-if="($mq === 'mobile')">
                                    <h5 v-if="tipoDocumentos.length==1">Envío de {{tipoDocumentoSelected.nombreDocumento}}</h5>
                                    <h5 v-else>Revisión de Documentos</h5>
                                </span>
                                <span v-else>
                                    <h4 v-if="tipoDocumentos.length==1">Envío de {{tipoDocumentoSelected.nombreDocumento}}</h4>
                                    <h4 v-else>Revisión de Documentos</h4>
                                </span>
                            </CCol>
                </CRow>
            </CCardHeader>
            <CCardBody>
                
                <CTabs :active-tab.sync="actTab" class="custom-tabs m-2" v-if="tabs.length > 0">
                    
                    <CTab  
                        v-for="(tab, index) in tabs" :key="index">
                        <template slot="title">
                            {{ getNombreTab(tab) }} 
                            <span v-if="tab.name != 'Principal'" 
                                @click="eliminarTab(index)" class="pi pi-times">
                            </span>
                        </template>
                        <div class="tab-content">
                            <RevDoc
                                :provTabPrincipal="(tab.name != 'Principal') ? false : true"
                                :empSel="tab.opciones.empresaSel"
                                :tipoDocSel="tab.opciones.tipoDocumentoSel"
                                :perSel="tab.opciones.periodoSel"
                                :tipoDocumentos="tipoDocumentos"
                                :periodos="periodos"
                                :empresasInfo="empresasInfo"
                                :verEnLista="tab.opciones.tablaLista"
                                @enviarNuevoTab="enviarNuevoTab"
                            />
                            <!--
                            opciones: {
                                "periodoSel": event[0],
                                "tipoDocumentoSel": event[1],
                                "empresaSel": event[2]
                            }
                            -->
                        </div>
                    </CTab>

                <!--<CTab style="background-color: azure; min-height: 100%;">
                    <template slot="title">
                        asdasd
                    </template>
                    <CCardBody>
                        asdasdasd
                    </CCardBody>
                </CTab>-->
                </CTabs>
                <span v-else>
                    <RevDoc
                        :provTabPrincipal="true"
                        :tipoDocumentos="tipoDocumentos"
                        :periodos="periodos"
                        :empresasInfo="empresasInfo"
                        :verEnLista="true"
                        :errorDctos="errorDctos"
                        @enviarNuevoTab="enviarNuevoTab"
                    />
                </span>
            </CCardBody>
        </CCard>
        
    </div>
</template>

<script>
    
    window.locale = 'es'
    /* Libs */
    import cons from '@/const'
    import axios from "axios"
    import apiUrls from '@/views/utils/apiUrls'
    import * as util from '@/views/utils/utilsFunctions'
    /* Fin Libs */

    

    import es from 'date-fns/locale/es'
    import { format, formatDistance, formatRelative, subDays, setYear, setMonth } from 'date-fns'

    
    import RevDoc from "@/views/remuneraciones/componentes/RevDoc";


    export default {
        name: 'RevisionDocumentos',
        components: {
            RevDoc
        },
        data () {
            return {
                actTab: 0,
                tabs: [],
                tokenLogin: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
                tipoUserAdmin: JSON.parse(this.$cookie.get('userLogginToken')).tipoUsuario,
                idCliente: JSON.parse(this.$cookie.get('userLogginToken')).idCliente,
                usaPortalEmpresa: JSON.parse(this.$cookie.get('userLogginToken')).usaPortalEmpresa,
                urlBase: cons.port+"://" + cons.ipServer,

                /**--------------------------- */
                

                /** Selecciones Iniciales */
                isLoadingPeriodos: false,
                isLoadingTipoDocumentos: false,
                isLoadingEmpresasInfo: false,

                periodos: [],
                tipoDocumentos: [],
                empresasInfo: [],

                
                
                empSelected: [],
                errorDctos: null,
                /** Fin Selecciones Iniciales */

                
            }
        },
        created: function(){},
        
        
        beforeMount() {
            let cookieUsername = this.$cookie.get('userLogginToken')
            if(cookieUsername === null || cookieUsername === ""){
                this.$router.push("/pages/login");
            }
            this.obtenerPeriodos()
            this.obtenerTiposDocumentos()
            this.obtenerSoloInfoEmpresas()

        },
        mounted(){

        },
        beforeDestroy () {
           
            
        },
        methods: {

            getNombreTab: function(tab){
                if(tab.name == "Principal"){
                    return tab.name
                }
                if(this.$mq === 'mobile'){
                    let p1 = `${tab.opciones.empresaSel.nombreEmpresa.substring(0, 5)}${tab.opciones.empresaSel.nombreEmpresa.length > 10 ? "..." : ""}`
                    let anioSel = format(tab.opciones.periodoSel, "yyyy", {locale: es})
                    let mesSel = format(tab.opciones.periodoSel, "MMM", {locale: es})
                    let p2 = `${tab.opciones.tipoDocumentoSel.nombreDocumento.substring(0, 3)}${tab.opciones.tipoDocumentoSel.nombreDocumento.length > 10 ? "..." : ""} - ${mesSel} ${anioSel}`
                    return `${p1} ${p2}`
                }

                return tab.name
            },

            enviarNuevoTab: function(event){
                let periodo = event[0]
                let anioSel = format(periodo, "yyyy", {locale: es})
                let mesSel = format(periodo, "MMM", {locale: es})
                let nombreEmpresa = `${event[2].nombreEmpresa.substring(0, 10)}${event[2].nombreEmpresa.length > 10 ? "..." : ""}`
                let tab = { 
                    name: `${nombreEmpresa} ${event[1].nombreDocumento} - ${mesSel} ${anioSel}`,
                    opciones: {
                        "periodoSel": event[0],
                        "tipoDocumentoSel": event[1],
                        "empresaSel": event[2],
                        "tablaLista" : event[3]
                    }
                }
                if(this.tabs.length == 0){
                    //agregar el primero
                    let opciPrincipal = structuredClone(tab)
                    opciPrincipal.name = "Principal"
                    opciPrincipal.opciones.empresaSel = null
                    this.tabs.push(opciPrincipal)
                }
                this.tabs.push(tab)
                this.actTab = this.tabs.length - 1
            },
            eliminarTab: function(index){
                this.tabs.splice(index, 1)
                this.actTab = this.tabs.length - 1
                
            },

            obtenerTiposDocumentos: function(){
                this.isLoadingTipoDocumentos = true

                var url =  this.urlBase + apiUrls.remuneraciones.getTipoDocumentos //"/get_tipo_documentos/"
                
                axios({
                    method: "GET", 
                    "url": url,
                    "headers": { 'Authorization': `${this.tokenLogin}`}
                }).then(result => {

                    this.tipoDocumentos = result.data

                    if(this.tipoDocumentos.length == 1){
                        this.tipoDocumentoSelected = this.tipoDocumentos[0]
                    }

                }, error => {
                    this.errorDctos = error.response.data
                })
                .finally(() => {
                    this.isLoadingTipoDocumentos = false
                });
            },
            obtenerPeriodos: function(){

                this.isLoadingPeriodos = true
                var url = this.urlBase + apiUrls.remuneraciones.getPeriodos

                axios({
                    method: "GET", 
                    "url": url,
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    this.periodos = result.data
                }, error => {
                    
                    this.mostrarNotificaciones(3, "Ups, Tuvimos un problema al obtener los periodos, si el problema persiste contacte con nuestro soporte, Gracias.")
                })
                .finally(() => {
                    this.isLoadingPeriodos = false
                });
            },       
            seleccionarPeriodoActual: function(){
                this.selectPeriodoActual = !this.selectPeriodoActual
                
                if(this.errorDctos != null){
                    this.mostrarNotificaciones(2, this.errorDctos)
                } else{
                    let anioActual = new Date().getFullYear()
                    let mesActual = new Date().getMonth()//se obtiene el anterior
                    if(mesActual == 0){
                        mesActual = 12
                        anioActual = anioActual - 1
                    }
                    if(this.selectPeriodoActual){
                        if(this.tipoDocumentoSelected == null)
                            this.tipoDocumentoSelected = this.tipoDocumentos[0]
                        
                        if(this.tipoDocumentoSelected.valor === "liquidaciones" || (this.tipoDocumentoSelected.valor === "contratos" && this.mostrarPeriodo)){
                            for(let periodo in this.periodos){
                                if(this.periodos[periodo].valor == anioActual){
                                    this.periodoSelected = this.periodos[periodo]
                                    let mesEncontrado = false

                                    for(let mes in this.periodoSelected.meses){
                                        if(this.periodoSelected.meses[mes].valor == mesActual){
                                            this.mesSelected = this.periodoSelected.meses[mes]
                                            mesEncontrado = true
                                            break
                                        }
                                    }
                                    if(mesEncontrado){
                                        this.periodoSeleccionado = new Date(anioActual, mesActual - 1)
                                        break
                                    }
                                }
                            }
                        }
                        this.obtenerEmpresas(this.tipoDocumentoSelected)
                    }
                }
            },
            disabledPeriodo: function(date, currentValue){
                let mesAct = format(date, "M", {locale: es})
                let anio = format(date, "yyyy", {locale: es})
                
                let mesNoEncontrado = true
                if(this.periodos !== null){
                    let anioEnc = this.periodos.find(per => per.valor == anio)
                    
                    if (anioEnc != null) {
                        mesNoEncontrado = anioEnc.meses.find(mes => mes.valor == parseInt(mesAct)) === undefined
                    }
                }

                return mesNoEncontrado
            },
            seleccionarTipoDocumento: function(tipoDoc){
                if(tipoDoc.valor =='contratos' && !this.mostrarPeriodo)
                    this.obtenerEmpresas(tipoDoc)
                else{
                    if(this.periodoSelected != null)
                        this.seleccionarAnioPeriodo(this.periodoSelected)
                    else{
                        this.empresas = []
                        this.empresasFiltradas = []
                    }
                }
            },
            seleccionarAnioPeriodo: function(periodoAnioSel){
                this.periodoSelected = periodoAnioSel
                this.empresas = []
                this.empresasFiltradas = []

                if(this.mesSelected != null){
                    let encontrado = false
                    this.periodoSelected.meses.forEach(mes =>{
                        if(mes.valor == this.mesSelected.valor){
                            encontrado = true
                            this.seleccionarMeses(mes)
                        }
                    })
                    if(!encontrado){
                        this.mostrarNotificaciones(2, `El año seleccionado no tiene el mes ${this.mesSelected.nombreMes}, se seleccionará el último disponible`)
                        this.seleccionarMeses(this.periodoSelected.meses[this.periodoSelected.meses.length - 1])
                    }
                }
            },
            validarSeleciones: function(validarFechas){
                if(this.tipoDocumentoSelected != null){
                    if(validarFechas){
                        let anioSel = format(this.periodoSeleccionado, "yyyy", {locale: es})
                        let mesSel = format(this.periodoSeleccionado, "M", {locale: es})
                        
                        let anioEnc = this.periodos.find(per => per.valor == anioSel)
                        
                        if (anioEnc != null) {
                            this.periodoSelected = anioEnc
                            let mesEnc = anioEnc.meses.find(mes => mes.valor == parseInt(mesSel))
                            if (mesEnc != null) {
                                this.mesSelected = mesEnc
                                this.obtenerEmpresas(this.tipoDocumentoSelected)
                            }

                        }
                    }

                }
            },
            seleccionarPeriodo: function(periodo){
                this.validarSeleciones(true)
            },
            seleccionarMeses: function(mes){

                this.mesSelected = mes
                if(this.tipoDocumentoSelected != null){
                    this.obtenerEmpresas(this.tipoDocumentoSelected)
                }
            },
            getOpciones: function(){
                return [
                    {
                        text: this.tipoDocumentoSelected.nombreDocumento,
                        addClasses: 'text-info'
                    }, 
                    {
                        text: `${this.mesSelected.nombreMes} ${this.periodoSelected.nombrePeriodo}`,
                        addClasses: 'text-info'
                    }
                ]
            },
            /*Fin Opciones Menus selecciones Iniciales */
            getDocsProcesados: function(archivosSubir){
                let archivosExitosos = 0
                let totalArchivos = archivosSubir.length
                let archivosProcesando = 0
                if(totalArchivos>0){
                    archivosSubir.forEach(file => {
                        if(file.active){
                            archivosProcesando++
                        }
                        if (file.success) {
                            archivosExitosos++
                        }
                    });
                }
                return archivosExitosos

            },
            getPorcentajeSubidos: function(archivosSubir){

                let archivosExitosos = 0
                let totalArchivos = archivosSubir.length
                let archivosProcesando = 0
                if(totalArchivos>0){
                    archivosSubir.forEach(file => {
                        if(file.active){
                            archivosProcesando++
                        }
                        if (file.success) {
                            archivosExitosos++
                        }
                    });

                    return ((archivosExitosos / totalArchivos) * 100)
                } else{
                    return 0
                }
            },
            getColorPorcentaje: function(archivosSubir){
                let algunError = false;
                let todosCompletados = true;

                archivosSubir.forEach(file => {
                    if (file.error) {
                        algunError = true;
                    }
                    if (!file.success) {
                        todosCompletados = false;
                    }
                });

                if (algunError) {
                    return "danger";
                }
                if (todosCompletados) {
                    return "success";
                }
                
                return "info";
                
            },
            /* proceso Revision */
            obtenerEmpresas: function(tipoDoc){
                this.tipoDocumentoSelected = tipoDoc
                if(this.tipoDocumentoSelected != null){
                    if(this.rqstEmps != null){
                        this.rqstEmps.cancel()
                        this.rqstEmps.msg = "cancelado";
                        this.rqstEmps = null;
                        
                        this.isLoadingEmpresas = false
                    }

                    const axiosSource = axios.CancelToken.source();
                    this.rqstEmps = { cancel: axiosSource.cancel, msg: "Cargando..." };
                    
                    this.empresas = []
                    this.empresasFiltradas = []
                    this.isLoadingEmpresas = true
                    let url =  this.urlBase + apiUrls.general.getEmpresas
                    
                    axios({
                        method: "POST", 
                        "url": url,
                        cancelToken: axiosSource.token,
                        "data": {
                            "tipoBD": "REMU",
                            "filtrarPorPeriodo": this.mostrarPeriodo,
                            "anioPeriodo": (this.periodoSelected != null) ? this.periodoSelected.valor : null,
                            "mesPeriodo":(this.mesSelected != null) ? this.mesSelected.valor : null,
                            "tipoDocumento": (this.tipoDocumentoSelected != null) ? this.tipoDocumentoSelected.valor : null,
                            "empSelecteds": this.emFlt,
                            "paginacionEmpresas": {
                                "actual": this.paginacionEmpresas.current,
                                "tamanioPagina": this.paginacionEmpresas.pageSize
                            }
                        },
                        "headers": {
                            'Authorization': `${this.tokenLogin}`
                        }
                    }).then(result => {
                        this.empresas = result.data.empresas
                        this.empresasFiltradas = result.data.empresas

                        for(var colum in this.columns){
                            
                            if(this.columns[colum].key === "rutEmpresa"){
                                this.columns[colum].filters = result.data.filtros.rutEmpresa
                            } else if(this.columns[colum].key === "nombreEmpresa"){
                                this.columns[colum].filters = result.data.filtros.nombreEmpresa
                            }
                        }

                        if(this.empresas.length<=0)
                            this.locale.emptyText = "No hay empresas para mostrar"

                        const pagination = { ...this.paginacionEmpresas };
                        pagination.total = result.data.totalEmpresas
                        this.paginacionEmpresas = pagination

                        this.isRefrescando = false
                        this.isLoadingEmpresas = false
                        this.selectPeriodoActual = false
                        this.rqstEmp = null
                        if(result.data.mensajeGeneral != null){
                            this.mostrarNotificaciones(2, result.data.mensajeGeneral)
                        }
                    }, 
                    /*cancel => {
                        
                    },*/
                    error => {
                        this.mostrarNotificaciones(3, error.response.data.mensajeGeneral)
                        this.isRefrescando = false
                        this.isLoadingEmpresas = false
                        this.selectPeriodoActual = false
                        this.rqstEmp = null
                    })
                    .finally(() => {
                    });
                }
            },
            seleccionarMostraPeriodo: function(){
                this.mostrarPeriodo = !this.mostrarPeriodo
                if(this.mostrarPeriodo){
                    if(this.tipoDocumentoSelected != null && this.mesSelected != null && this.periodoSelected != null){
                        this.obtenerEmpresas(this.tipoDocumentoSelected)
                    } else{
                        this.empresas = []
                        this.empresasFiltradas = []
                    }
                }
                else{
                    if(this.tipoDocumentoSelected != null){
                        this.obtenerEmpresas(this.tipoDocumentoSelected)
                    }
                    else{
                        this.empresas = []
                        this.empresasFiltradas = []
                    }
                }
            },
            cerrarModalInfoEmpresa: function(){
                this.empresaSeleccionadaInfo = {}
                this.infoEmpresaModal = false;
            },
            cancelarEnvio: function(){
                this.mailEmpresaOk = true
                this.mensajeCorreoInvalido = false
                this.mailValido = true
                //this.mailEmpresaRespaldo = ""
                this.modificarCorreoEmpresa = false
                this.empresaEnviada = false

                this.empresaEnviar.userNotificar.forEach(user => {
                    user.mailUser = user.mailRespaldo
                })
                this.respEmpresaEnviar = {}
            },
            enviarEmpresa: function(empresa){
                this.mensajeBoton = 'Enviando'

                this.respEmpresaEnviar = empresa

                this.mailEmpresaOk = true
                this.mensajeCorreoInvalido = false
                this.mailValido = true
                //this.mailEmpresaRespaldo = ""
                this.modificarCorreoEmpresa = false
                this.empresaEnviada = false

                if(empresa.userNotificar.length == 0){

                    this.mailEmpresaOk = false
                    this.mailValido = false
                    this.modificarCorreoEmpresa = true

                } else{

                    empresa.userNotificar.forEach(user => {

                        if(util.validarMail(user.mailUser)){
                            user.mailValidado = true
                        } else {
                            this.mailEmpresaOk = false
                            this.mailValido = false
                            user.mailValidado = false
                            this.modificarCorreoEmpresa = true
                        }

                    })
                }

                this.empresaEnviar = empresa
                //this.mailEmpresaRespaldo = empresa.userNotificar.mailUser
                this.mostrarModalEnvioEmpresa = true
            },
            cancelarRevision: function(empresa){
                empresa.cancelandoEnvio = true
                let url = `${this.urlBase + apiUrls.revisionDocumentos.cancelarRevision}`
                axios({
                    url: url,
                    method: "POST",
                    "data": {
                        "datosRevision": {
                            "tipoDocumento": (this.tipoDocumentoSelected != null) ? this.tipoDocumentoSelected.valor : null,
                            "mesPeriodo": (this.mesSelected != null) ? this.mesSelected.valor : null,
                            "anioPeriodo": (this.periodoSelected != null) ? this.periodoSelected.valor : null,
                            "idEmpresa": empresa.idEmpresa,
                            "mostrarPorPeriodo": this.mostrarPeriodo,
                            "userNotificar": empresa.userNotificar,
                        }
                    },
                    headers: {
                        Authorization: `${this.tokenLogin}`,
                    },
                })
                .then((result) => {

                        this.mostrarNotificaciones(1,`Se ha cancelado la revision de la empresa ${empresa.nombreEmpresa}`)
                        empresa.estado = result.data.estadoEmpresa
                        this.obtenerTrabajadores(this.empresas[this.empresas.indexOf(empresa)].expandirEmpresa, this.empresas[this.empresas.indexOf(empresa)])
                    },
                    (error) => {
                        this.mostrarNotificaciones(3, error.response.data.mensaje)
                    }
                )
                .finally(() => {
                    empresa.cancelandoEnvio = false
                    
                });
            },
            
            aceptarEmpresa: function (empresa) {
                this.mensajeBoton = 'Aceptando'

                empresa.enviandoEmpresa = true
                let url = `${this.urlBase}/aceptar_documentos/${empresa.idEmpresa}/${(this.mesSelected != null) ? this.mesSelected.valor : 'null'}/${(this.periodoSelected != null) ? this.periodoSelected.valor : 'null'}/${(this.tipoDocumentoSelected != null) ? this.tipoDocumentoSelected.valor : 'null'}`
                //var url = this.urlBase + "/aceptar_documentos/" + empresa.idEmpresa + "/" + this.mesSelected.valor + "/" + this.periodoSelected.valor + "/" + this.tipoDocumentoSelected.valor;
                axios({
                    url: url,
                    method: "POST",
                    "data": {
                        "info": {
                            "notificarMail": empresa.notificar.mail,
                            "notificarPlataorma": empresa.notificar.plataforma,
                        }
                    },
                    headers: {
                        Authorization: `${this.tokenLogin}`,
                    },
                })
                    .then(
                    (result) => {
                        //this.selempresa.estado = result.data.estadoEmpresa;
                        
                        this.mostrarNotificaciones(1, result.data.mensaje)
                        //this.$notification.success(result.data.mensaje, { timer: 10, position: "bottomRight" });
                        empresa.estado = result.data.estadoEmpresa;
                        empresa.fechaRespuesta = result.data.fechaModif

                        empresa.enviandoEmpresa = false
                        this.obtenerTrabajadores(this.empresas[this.empresas.indexOf(empresa)].expandirEmpresa, this.empresas[this.empresas.indexOf(empresa)])
                    },
                    (error) => {
                        this.mostrarNotificaciones(3, error.response.data.mensaje)
                        //this.$notification.error(error.response.data.mensaje, {timer: 10, position: "bottomRight"});
                        empresa.enviandoEmpresa = false
                    }
                    )
                    .finally(() => {
                    });
                },
            cerrarPeriodo: function(empresa){
                let url = `${this.urlBase}/abrir_cerrar_periodo_empresa/${empresa.idEmpresa}/${(this.mesSelected != null) ? this.mesSelected.valor : 'null'}/${(this.periodoSelected != null) ? this.periodoSelected.valor : 'null'}/2`//2 - cerrar

                //var url = this.urlBase + "/abrir_cerrar_periodo_empresa/" + empresa.idEmpresa + "/" + this.mesSelected.valor + "/" + this.periodoSelected.valor + "/" + 2;//2 - cerrar

                axios({
                    method: "POST",
                    url: url,
                    headers: {
                        Authorization: `${this.tokenLogin}`,
                    },
                    }).then((result) => {
                        
                        this.$notification.success(`Se ha Cerrado el periodo ${this.mesSelected.nombreMes}-${this.periodoSelected.valor}, ${empresa.nombreEmpresa}`, {  timer: 10, position:"bottomRight", showCloseIcn:true});
                        empresa.periodoCerrado = true;
                        empresa.fechaPeriodoCerrado = result.data.fechaModificacion;
                    },
                    (error) => {
                        this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight", showCloseIcn:true});
                    })
                    .finally(() => {
                    });
            },
            abrirPeriodo: function(empresa){

                var url = cons.port+"://" + cons.ipServer + "/abrir_cerrar_periodo_empresa/" + empresa.idEmpresa + "/" + this.mesSelected.valor + "/" + this.periodoSelected.valor + "/" + 1;//1 - abrir

                axios({
                    method: "POST",
                    url: url,
                    headers: {
                        Authorization: `${this.tokenLogin}`,
                    },
                    }).then((result) => {
                        this.$notification.success(`Se ha Abierto el periodo ${this.mesSelected.nombreMes}-${this.periodoSelected.valor}, ${empresa.nombreEmpresa}`, {  timer: 10, position:"bottomRight", showCloseIcn:true});
                        empresa.periodoCerrado = false;
                    },
                    (error) => {
                        
                        this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight", showCloseIcn:true});
                    })
                    .finally(() => {
                    });
            },
            
            seleccionFiltro: function(evento, empresa){
                empresa.opcionSeleccionadaFiltro = evento
                this.obtenerTrabajadores(true, empresa)
            },
            //TrabajadoresFiltro
            getTrabajadores: function(expand, empresa){
                if(expand){
                    empresa.currentPageFiltros = 1
                    empresa.trabajadoresFiltro = []
                }
                
                if(empresa.rqstTrabs != null){
                    empresa.rqstTrabs.cancel()
                    empresa.rqstTrabs.msg = "cancelado";
                    empresa.rqstTrabs = null;
                    
                    empresa.isLoadingTrabajadoresFiltros = true;
                }
                const axiosSource = axios.CancelToken.source();
                empresa.rqstTrabs = { cancel: axiosSource.cancel, msg: "Cargando..." };

                empresa.isLoadingTrabajadoresFiltros = true;
                
                let url = `${this.urlBase + apiUrls.general.getTrabajadoresEmpresa + empresa.idEmpresa}/${(this.tipoDocumentoSelected != null) ? this.tipoDocumentoSelected.valor : 'null'}/${(this.mesSelected != null) ? this.mesSelected.valor : 'null'}/${(this.periodoSelected != null) ? this.periodoSelected.valor : 'null'}`


                axios({
                method: "POST",
                url: url,
                cancelToken: axiosSource.token,
                "data": {
                    "filtrarPorPeriodo": this.mostrarPeriodo,
                    "paginacionTrabajadores": {
                        "strFiltro": empresa.strFiltroTrabajadores,
                        "actual": empresa.currentPageFiltros,
                        "tamanioPagina": 10,
                        "filtros": empresa.opcionSeleccionadaFiltro
                    }
                },
                headers: {
                    Authorization: `${this.tokenLogin}`,
                },
                }).then((result) => {
                    empresa.totalPages = Number((result.data.totalTrabajadores/10).toFixed(0))
                    if(empresa.trabajadoresFiltro.length == 1 && empresa.trabajadoresFiltro[0].rutTrabajador == '0'){
                        empresa.trabajadoresFiltro = []
                    }

                    empresa.trabajadoresFiltro = empresa.trabajadoresFiltro.concat(result.data.trabajadores)
                    empresa.currentPageFiltros++
                    
                    empresa.isLoadingTrabajadoresFiltros = false;
                    empresa.rqstTrabs = null;
                    if(result.data.mensajeGeneral != null){
                        this.mostrarNotificaciones(2, result.data.mensajeGeneral)
                        //this.$notification.warning(result.data.mensajeGeneral, {  timer: 10, position:"bottomRight", showCloseIcn:true});
                    }
                },
                cancel =>{
                    empresa.isLoadingTrabajadoresFiltros = false;

                },
                (error) => {
                    
                    empresa.isLoadingTrabajadoresFiltros = false;
                    empresa.rqstTrabs = null;

                }
                )
                .finally(() => {
                    empresa.isLoadingTrabajadoresFiltros = false;
                });
            },
            enviaraTodos: function(empresa){
                var msjOriginal = empresa.txtEnviarTodos
                empresa.isLoadingEnvioTodos = true
                empresa.txtEnviarTodos = "enviando"
                var url = cons.port+"://" + cons.ipServer + "/" + "enviar_documento_trabajador/"

                var trabajadores = []
                if(empresa.trabajadoresFiltrados != null && empresa.trabajadoresFiltrados.length > 0){
                    empresa.trabajadoresFiltrados.forEach(trabajador => {
                        trabajadores.push({"rutTrabajador": trabajador.rutTrabajador})
                    });
                }

                axios({
                    method: "POST",
                    url: url,
                    "data": {
                        "trabajadoresEnviar": {
                        "enviarTodos": true,
                        "idEmpresa": empresa.idEmpresa,
                        "anioPeriodo": (this.periodoSelected != null) ? this.periodoSelected.valor : 'null',
                        "mesPeriodo": (this.mesSelected != null) ? this.mesSelected.valor : 'null',
                        "tipoDoc": this.tipoDocumentoSelected.valor,
                        "filtrarPorPeriodo": this.filtrarPorPeriodo,
                        "trabajadores":trabajadores
                        }
                    },
                    headers: {
                        Authorization: `${this.tokenLogin}`,
                    },
                    })
                    .then((result) => {
                        this.$notification.success(
                        result.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                        );
                        //this.obtenerTrabajadores(true, empresa)
                    },
                    (error) => {
                        this.$notification.error(
                        error.response.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                        );
                    }
                    )
                    .finally(() => {
                        empresa.txtEnviarTodos = msjOriginal
                        empresa.isLoadingEnvioTodos = false
                    });

            },
            rmvEmpSel: function(emp){
                for(var indx=0;indx<=this.emFlt.length;indx++){
                    if(this.emFlt[indx].idEmpresa == emp.idEmpresa){
                        this.emFlt.splice(indx, 1)
                        break;
                    }
                }

                if(this.mesSelected != null && this.periodoSelected != null)
                    this.obtenerEmpresas(this.tipoDocumentoSelected)
                
            },
            filtrarEmpr: function(emp){
                this.emFlt.push(emp)
                if(this.mostrarPeriodo){
                    if(this.mesSelected != null && this.periodoSelected != null)
                        this.obtenerEmpresas(this.tipoDocumentoSelected)
                } else{
                    this.obtenerEmpresas(this.tipoDocumentoSelected)
                }
                
            },
            customLabelEmp (empresa) {
                return `(${empresa.codEmpresa}) ${empresa.nombreEmpresa}`;
            },
            customTrabajador: function(trabajador) {
                if(trabajador.rutTrabajador == '0'){
                    return 'Buscando...'
                }else {
                    return `${trabajador.rutTrabajador} – ${trabajador.nombreTrabajador} ${(trabajador.documentos.length >0)?"":"(Sin Documento)"}`
                }
            }, 
            descargarArchivo: function(tipoDescarga, empresa){
                empresa.isDescargando = true
                
                let url = this.urlBase + `/descargar_documentos/`
                let trabajadores = []
                if(empresa.trabajadoresFiltrados != null && empresa.trabajadoresFiltrados.length > 0){
                    empresa.trabajadoresFiltrados.forEach(trabajador => {
                        trabajadores.push({"rutTrabajador": trabajador.rutTrabajador})
                    });
                }
                axios({
                    url: url,
                    method: 'POST',
                    "data": {
                        "tipoBd": "REMU",
                        "tipoDescarga": tipoDescarga,
                        "codEmpresa": empresa.codEmpresa,
                        "idEmpresa": empresa.idEmpresa,
                        "filtrarPorPeriodo": this.mostrarPeriodo,
                        "anioPeriodo": (this.periodoSelected != null) ? this.periodoSelected.valor : null,
                        "mesPeriodo":(this.mesSelected != null) ? this.mesSelected.valor : null,
                        "tipoDocumento": (this.tipoDocumentoSelected != null) ? this.tipoDocumentoSelected.valor : null,
                        "infoTrabajadores": {
                            "trabajadoresSelected": [],
                            "trabajadores": trabajadores
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    },

                }).then((response) => {
                    //this.msjDescargando = "Iniciando Descarga"

                    //this.$notification.success(response.mensajeGeneral, {  timer: 10, position:"bottomRight", showCloseIcn:true});
                    //this.mostrarNotificaciones(1, response.data.mensajeGeneral)
                    const link = document.createElement('a')
                    link.href = response.data.archivo.link
                    link.download = response.data.archivo.nombre
                    link.click()
                    URL.revokeObjectURL(link.href)

                    //this.$notification.success("Iniciando Descarga", {  timer: 10, position:"bottomRight", showCloseIcn:true});
                    this.mostrarNotificaciones(1, `${response.data.mensajeGeneral}, Iniciando Descarga`)

                }, error => {
                    this.mostrarNotificaciones(3, error.response.data.mensajeGeneral)
                    //this.$notification.error(error.response.data.mensajeGeneral, {  timer: 10, position:"bottomRight", showCloseIcn:true});
                })
                .finally(() => {
                    empresa.isDescargando = false
                });
                
            },
            
            isEmailValido: function() {
                var hayInvalido = false

                this.empresaEnviar.userNotificar.forEach(user => {
                    
                    if(util.validarMail(user.mailUser)){
                        user.mailValidado = true
                        user.editCorreoEncargado = false
                    } else {
                        this.mailEmpresaOk = false
                        this.mailValido = false
                        user.mailValidado = false
                        this.modificarCorreoEmpresa = true
                        hayInvalido = true
                    }

                })

                if(!hayInvalido){
                    this.mailEmpresaOk = true
                    this.mailValido = true
                }
            },
            editarCorreoEmpresa: function(user){
                user.editCorreoEncargado = !user.editCorreoEncargado
                this.modificarCorreoEmpresa = true
                user.mailRespaldo = user.mailUser

            },
            cancelarEditarEmpresa: function(user){
                if(user.mailUser != user.mailRespaldo)
                    user.mailUser = user.mailRespaldo
                
                user.editCorreoEncargado = false
            },
            actualizarDocumentosEncontrados: function(empresa, trabajadores){

                let url =  this.urlBase + apiUrls.remuneraciones.actualizarDocumentos

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "infoActualizar": {
                            "idEmpresa": empresa.idEmpresa,
                            "tipoBD": "REMU",
                            "tipoDocumentos": this.tipoDocumentoSelected.valor,
                            "mes": this.mesSelected.valor,
                            "anio": this.periodoSelected.valor,
                            "trabajadores": trabajadores
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    empresa.mensajeActualizacionDocs = result.data
                    empresa.mostrarMensajeActualizacionDocumentos = true
                    this.obtenerTrabajadores(true, empresa)
                    this.mostrarNotificaciones(1, result.data.mensajeGeneral, 20)
                }, error => {
                    
                    if("tipoMensaje" in error.response.data && "mensajeGeneral" in error.response.data){
                        if(error.response.data.tipoMensaje == "alerta"){
                            this.mostrarNotificaciones(2, error.response.data.mensajeGeneral)
                        } else {
                            this.mostrarNotificaciones(3, error.response.data.mensajeGeneral)
                        }
                    } else{
                        this.mostrarNotificaciones(3, error.response.data.mensajeGeneral)
                    }
                })
                .finally(() => {
                    empresa.isActualizandoDocumentos = false
                    if(empresa.trabajadoresFiltrados.length > 0 ){
                        empresa.txtActualizarDocs = "Actualizar Documentos Trabajadores Seleccionados"
                    } else{
                        empresa.txtActualizarDocs = "Actualizar Documentos"
                    }
                    
                });

            },
            actualizarDocumentosEmpresa: function(empresa){
                empresa.isActualizandoDocumentos = true
                empresa.txtActualizarDocs = "Revisando Documentos"

                var trabajadores = []
                if(empresa.trabajadoresFiltrados != null && empresa.trabajadoresFiltrados.length > 0){
                    empresa.trabajadoresFiltrados.forEach(trabajador => {
                        trabajadores.push({"rutTrabajador": trabajador.rutTrabajador})
                    });
                }
                
                let url = this.urlBase + apiUrls.remuneraciones.revisarActualizarDocumentos

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "infoActualizar": {
                            "idEmpresa": empresa.idEmpresa,
                            "tipoBD": "REMU",
                            "tipoDocumentos": this.tipoDocumentoSelected.valor,
                            "mes": this.mesSelected.valor,
                            "anio": this.periodoSelected.valor,
                            "trabajadores": trabajadores
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    this.mostrarNotificaciones(2, result.data.mensajeGeneral)
                    if(result.data.validoContinuar){
                        this.actualizarDocumentosEncontrados(empresa, trabajadores)
                    } else{
                        empresa.isActualizandoDocumentos = false
                    }
                }, error => {
                    empresa.isActualizandoDocumentos = false
                    if("tipoMensaje" in error.response.data && "mensaje" in error.response.data){
                        if(error.response.data.tipoMensaje == "alerta"){
                            this.mostrarNotificaciones(2, error.response.data.mensajeGeneral)
                        } else {
                            this.mostrarNotificaciones(3, error.response.data.mensajeGeneral)
                        }
                    } else{
                        this.mostrarNotificaciones(3, error.response.data.mensajeGeneral)
                    }
                })
                .finally(() => {
                    
                });
                
                /*let url =  this.urlBase + apiUrls.remuneraciones.actualizarDocumentos

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "infoActualizar": {
                            "idEmpresa": empresa.idEmpresa,
                            "tipoBD": "REMU",
                            "tipoDocumentos": this.tipoDocumentoSelected.valor,
                            "mes": this.mesSelected.valor,
                            "anio": this.periodoSelected.valor,
                            "trabajadores": trabajadores
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    empresa.mensajeActualizacionDocs = result.data
                    empresa.mostrarMensajeActualizacionDocumentos = true
                    this.obtenerTrabajadores(true, empresa)
                    this.$notification.success(result.data, {  timer: 10, position:"bottomRight"});
                }, error => {
                    if("tipoMensaje" in error.response.data && "mensaje" in error.response.data){
                        if(error.response.data.tipoMensaje == "alerta"){
                            this.mostrarNotificaciones(2, error.response.data.mensaje)
                        } else {
                            this.mostrarNotificaciones(3, error.response.data.mensaje)
                        }
                    } else{
                        this.mostrarNotificaciones(3, error.response.data.mensaje)
                    }
                })
                .finally(() => {
                    empresa.isActualizandoDocumentos = false
                    if(empresa.trabajadoresFiltrados.length > 0 ){
                        empresa.txtActualizarDocs = "Actualizar Documentos Trabajadores Seleccionados"
                    } else{
                        empresa.txtActualizarDocs = "Actualizar Documentos"
                    }
                    
                });*/

            },
            
            obtenerSoloInfoEmpresas: function(){
                this.isLoadingEmpresasInfo = true
                
                var url = this.urlBase + apiUrls.general.getEmpresasInfo+"/REMU"
                
                axios({
                    method: "GET", 
                    "url": url,
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    
                    this.empresasInfo = result.data;

                }, error => {
                    //let mensaje = `Problema al obtener empresas , ${error}`
                })
                .finally(() => {
                    this.isLoadingEmpresasInfo = false
                });
            },


        }
        
    }
</script>

<style>

/*-------------------------------------*/
/* Estilizar la barra de pestañas */

/* Estilizar cada pestaña */

/* Estilizar el título de la pestaña */

/* Efecto de pestaña activa */

/* Contenido de la pestaña */
.custom-tabs .tab-content {
  background: white;
  padding: 10px;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
</style>